import solicitacaoProcessoModel from '@/components/abertura/solicitacaoProcesso.json';
import { ISO_DATE } from '@/utils/dateFormats';
import { format, utcToZonedTime } from 'date-fns-tz';
import Vue from 'vue';

export default {
  SET_SOLICITACOES_PROCESSO(state, payload) {
    state.solicitacoesProcesso = payload;
  },
  SET_SOLICITACAO_PROCESSO(state, payload) {
    const solicitacaoProcesso = {};

    Object.assign(
      solicitacaoProcesso,
      { ...solicitacaoProcessoModel },
      payload,
    );

    let arquivos = [];

    if (payload.documentos) {
      arquivos = payload.documentos.map((documento) => ({
        ...documento,
        key: documento._id,
      }));
    }

    Vue.set(solicitacaoProcesso, 'arquivos', arquivos);

    let itens = [];

    if (payload.itens) {
      itens = payload.itens.map((item) => ({ ...item, key: item._id }));
    }

    Vue.set(solicitacaoProcesso, 'itens', itens);

    if (payload.eta) {
      const zonedDate = utcToZonedTime(new Date(payload.eta), 'Etc/UTC');

      solicitacaoProcesso.eta = format(zonedDate, ISO_DATE);
    }

    if (payload.etd) {
      const zonedDate = utcToZonedTime(new Date(payload.etd), 'Etc/UTC');

      solicitacaoProcesso.etd = format(zonedDate, ISO_DATE);
    }

    state.solicitacaoProcesso = solicitacaoProcesso;
  },
  REMOVE_SOLICITACAO(state, payload) {
    const index = state.solicitacoesProcesso.findIndex((solicitacao) => solicitacao.id === payload);
    if (index !== undefined) {
      Vue.delete(state.solicitacoesProcesso, index);
    }
  },
  SET_TIPOS_PROCESSO(state, payload) {
    state.tiposProcesso = payload;
  },
  SET_STATUS_SOLICITACAO_PROCESSO(state, payload) {
    state.statusSolicitacaoProcesso = payload;
  },
  SET_TIPOS_DOCUMENTO(state, payload) {
    state.tiposDocumento = payload;
  },
  ABRIR_MODAL(state) {
    state.abrirModal = true;
  },
  ABRIR_MODAL_VISUALIZACAO(state) {
    state.abrirModalVisualizacao = true;
  },
  ABRIR_MODAL_ORDEM(state) {
    state.abrirModalOrdemCompra = true;
  },
  FECHAR_MODAL(state) {
    state.abrirModal = false;
  },
  FECHAR_MODAL_VISUALIZACAO(state) {
    state.abrirModalVisualizacao = false;
  },
  FECHAR_MODAL_ORDEM(state) {
    state.abrirModalOrdemCompra = false;
  },
  SET_PROCESSO_VISUALIZACAO(state, payload) {
    state.isVisualizar = payload;
  },
  SET_PROCESSO_ALTERACAO(state, payload) {
    state.isAlterar = payload;
  },
  SET_EXPORTADORES(state, payload) {
    state.exportadores = payload;
  },
  SET_EM_ALTERACAO(state, payload) {
    state.emAlteracao = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
  ATIVAR_DOWNLOAD_ORDEM(state) {
    state.downloadOrdem = true;
  },
  DESATIVAR_DOWNLOAD_ORDEM(state) {
    state.downloadOrdem = false;
  },
  ATIVAR_DOWNLOAD_PROCESSO(state) {
    state.downloadProcesso = true;
  },
  DESATIVAR_DOWNLOAD_PROCESSO(state) {
    state.downloadProcesso = false;
  },
  ADICIONAR_RASCUNHO(state, rascunho) {
    const payload = { ...rascunho, ultimaModificacao: new Date() };
    Vue.set(state.rascunhos, rascunho._rascunhoId, payload);
  },
};
